import React, { useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import ThankYouContext from '../Context';
import ThankYouReducer from '../Reducer';
import {
  USER_INFO, DATA_OXXO, DATA_SPEI, DATA_CARD,
} from '../types';

const ThankYouState = ({ children }) => {
  const initialstate = {
    user: {},
    dataOxxo: localStorage.getItem('dataOxxo'),
    dataSpei: localStorage.getItem('dataSpei'),
    dataCard: localStorage.getItem('dataCard'),
  };

  const [state, dispatch] = useReducer(ThankYouReducer, initialstate);

  const updateUserInformation = (data) => {
    dispatch({
      type: USER_INFO,
      payload: data,
    });
  };

  const setDataOxxo = (data) => {
    dispatch({
      type: DATA_OXXO,
      payload: localStorage.setItem('dataOxxo', JSON.stringify(data)),
    });
  };

  const setDataSpei = (data) => {
    dispatch({
      type: DATA_SPEI,
      payload: localStorage.setItem('dataSpei', JSON.stringify(data)),
    });
  };

  const setDataCard = (data) => {
    dispatch({
      type: DATA_CARD,
      payload: localStorage.setItem('dataCard', JSON.stringify(data)),
    });
  };

  const contextValue = useMemo(() => {
    return {
      user: state.user,
      dataOxxo: state.dataOxxo,
      dataSpei: state.dataSpei,
      dataCard: state.dataCard,
      updateUserInformation,
      setDataOxxo,
      setDataSpei,
      setDataCard,
    };
  }, [
    state.user,
    state.dataOxxo,
    state.dataSpei,
    state.dataCard,
    updateUserInformation,
    setDataOxxo,
    setDataCard,
  ]);

  return (
    <ThankYouContext.Provider value={contextValue}>
      {children}
    </ThankYouContext.Provider>
  );
};

export default ThankYouState;

ThankYouState.propTypes = {
  children: PropTypes.node.isRequired,
};
